import { useFirestoreInvalidation } from '@hooks/useFirestoreInvalidation'

export const useNotificationInvalidation = (clientId: number | undefined) => {
  useFirestoreInvalidation(clientId, 'notifications', ['NotificationsCount', 'NotificationTable'])
}
